import React from 'react';
import type { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(-67.25 -238.039)">
      <circle
        cx="15"
        cy="15"
        r="15"
        transform="translate(68 238.789)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <g transform="translate(82.999 238.789)">
        <path
          d="M1760.736-357.28h0a14.93,14.93,0,0,0,2.007-7.5,15,15,0,0,0-15-15v15Z"
          transform="translate(-1747.746 379.78)"
          fill={color}
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
    </g>
  </svg>
);
